module.exports = __webpack_public_path__ + "assets/btc-white-icon.08b64562.svg";